import React from 'react'
import PropTypes from 'prop-types'
import IssueTypeDropdown from './issueTypeDropdown'
import AutoFocus from '../AutoFocus'
import { Modal } from 'react-bootstrap'

import classnames from 'classnames'
import style from './style.css'

export default function ChallengeQuestionModal (props) {
  const challengeValueError = props.uiState.challengeQuestionError
  const challengeIssueTypeError = props.uiState.challengeQuestionErrorIssueType
  const challengeValue = props.uiState.challengeQuestionValue
  const challengeEmailValue = props.uiState.challengeEmailValue
  const challengeEmailError = props.uiState.challengeQuestionErrorEmail

  function renderFirstStep () {
    return (
      <div>
        <p className={style.content}>
          Tell us a little more about the issue you're experiencing.
        </p>
        <div className={style.challengeContainer}>
          <IssueTypeDropdown
            issueType={props.uiState.challengeIssueTypeValue}
            onSelect={props.onChallengeIssueTypeChange}
          />
          {challengeIssueTypeError
            ? <AutoFocus tabIndex="0">
              <div className={style.errorMessage}>You must select one type.</div>
            </AutoFocus>
            : null
          }
          <label
            className={classnames(style.challengeLabel)}
          >
            Suggested improvement:
          </label>
          <textarea
            className={classnames(style.challenge, challengeValueError ? style.challengeError : null)}
            value={challengeValue}
            onChange={props.onChallengeQuestionChange}
          />
          {challengeValueError
            ? <AutoFocus tabIndex="0">
              <div className={style.errorMessage}>Your suggestion must be at least 50 characters long.</div>
            </AutoFocus>
            : null
          }
        </div>
      </div>
    )
  }

  function renderSecondStep () {
    return (
      <div>
        <p className={style.content}>
          In case we need to contact you for additional information, please provide your email.
        </p>
        <div className={style.challengeContainer}>
          <label
            className={style.challengeLabel}
          >
            Email(optional)
          </label>
          <input
            type="email"
            className={style.challengeEmailInput}
            value={challengeEmailValue}
            onChange={props.onChallengeEmailChange}
          />
          {
            challengeEmailError
              ? <AutoFocus tabIndex="0">
                <div className={style.errorMessage}>The email don't have a valid format.</div>
              </AutoFocus>
              : null
          }
        </div>
      </div>
    )
  }

  return (
    <Modal show={true} className={classnames(style.modalContainer)}>
      <div className={style.containerModal} tabIndex="0">
        <Modal.Header className={classnames('modal-header', style.headerContainer)}>
          <Modal.Title className={style.modalTitle}>Problem with this question?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.uiState.challengeStep !== CHALLENGE_EMAIL_STEP
            ? renderFirstStep()
            : renderSecondStep()
          }
        </Modal.Body>
        <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
          <button
            aria-label="Send report"
            className={classnames('btn-cdl-main', style.modalSubmit)}
            onClick={props.onSendChallenge}
          >
            {props.uiState.challengeStep === CHALLENGE_EMAIL_STEP ? 'Submit' : 'Continue'}
          </button>
          <button
            aria-label="Cancel"
            className={classnames('btn-cdl-secondary', style.modalClose)}
            onClick={props.onCancel}
          >
            Cancel
          </button>
        </Modal.Footer>
      </div>
    </Modal>
  )
}

export const CHALLENGE_EMAIL_STEP = 'CHALLENGE_EMAIL_STEP'

ChallengeQuestionModal.propTypes = {
  uiState: PropTypes.object.isRequired,
  onChallengeQuestionChange: PropTypes.func.isRequired,
  onChallengeIssueTypeChange: PropTypes.func.isRequired,
  onChallengeEmailChange: PropTypes.func.isRequired,
  onSendChallenge: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}
